import { pickBy } from "lodash-es"

export interface IOmitUndefinedObj {
    [k: string]: any;
}

export const omitUndefined = (obj: IOmitUndefinedObj) => {
    return pickBy(obj, value => typeof value !== 'undefined');
}
